import { render } from "./FuelTypesComponent.vue?vue&type=template&id=52dac054&ts=true"
import script from "./FuelTypesComponent.vue?vue&type=script&lang=ts"
export * from "./FuelTypesComponent.vue?vue&type=script&lang=ts"

import "./FuelTypesComponent.vue?vue&type=style&index=0&id=52dac054&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__